var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('colikado-summary-by-product-type'),_c('colipays-summary-by-product-type'),_c('summary-by-reception-type'),_c('summary-graph')],1)}
var staticRenderFns = []

export { render, staticRenderFns }